module.exports = __webpack_public_path__ + "img/15.4.NH3-N.20133148.png";